export default __webpack_public_path__ + "static/media/vera.69e3fa3a.jpg";